import React from "react";
import { CheckCircle2 } from "lucide-react";
import { EnrollButtons } from "@/components/EnrollButtons";
import { BatchInfo } from "@/components/BatchInfo";
import { COURSE_NAME, ORIGINAL_PRICE, PRICE, DISCOUNT, modules } from "@/lib/courseData";

const inr = (n) => `₹${n.toLocaleString("en-IN")}`;

export const PricingCard = () => (
  <section id="pricing" className="max-w-7xl mx-auto px-6 lg:px-10 py-24 scroll-mt-20">
    <div className="relative overflow-hidden rounded-lg border border-fin-green/40 bg-[#141414] p-8 md:p-14 grid md:grid-cols-2 gap-10 items-center">
      <div>
        <div className="inline-block bg-fin-green text-black text-[10px] font-bold tracking-overline px-2.5 py-1 rounded-sm mb-5" data-testid="pricing-discount-badge">
          {DISCOUNT}% OFF
        </div>
        <h2 className="font-display text-3xl md:text-4xl text-white mb-4">{COURSE_NAME}</h2>
        <div className="flex items-baseline gap-3 mb-6">
          <span className="font-mono text-5xl text-fin-green" data-testid="pricing-price">{inr(PRICE)}</span>
          <span className="font-mono text-xl text-white/40 line-through" data-testid="pricing-original-price">{inr(ORIGINAL_PRICE)}</span>
        </div>
        <div className="mb-6"><BatchInfo id="pricing" /></div>
        <p className="text-white/60 mb-8 max-w-md">Message us on WhatsApp or call to reserve your seat and get batch details.</p>
        <EnrollButtons id="pricing" />
      </div>
      <ul className="space-y-3 md:border-l md:border-white/10 md:pl-10">
        {modules.map((m, i) => (
          <li key={m.title} className="flex items-start gap-3 text-white/80 text-sm">
            <CheckCircle2 className="h-5 w-5 text-fin-green shrink-0" />
            <span><span className="font-mono text-white/40 mr-2">M{i + 1}</span>{m.title}</span>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
